import { Breakpoints, styled } from "@volkswagen-onehub/components-core";

import { VWTheme } from "../../../../shared/typings/vw-theme";

export const StyledDeactiveAccountNoVehicleUserContainer = styled.div`
  height: 83svh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: ${(props) => props.theme.size.static350};

  @media (min-width: ${Breakpoints.b560}px) {
    margin-top: ${(props) => props.theme.size.static400};
  }
`;

export const StyledDeactiveAccountNoVehicleUserCTAContainer = styled.div`
  display: flex;
  min-width: 196px;
  justify-content: flex-end;
  align-items: center;

  ${({ theme }) => {
    return `
      gap: ${theme.size.static350};
    `;
  }}
`;

interface StyledGenericProps {
  theme: VWTheme
  hasDescription: boolean;
}

export const StyledUserVehiclesAndServicesContainer: any = styled.div`
  ${({ theme }: StyledGenericProps) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static400};
      height: 100%;
      margin-top: ${theme.size.static350};

      @media (min-width: ${Breakpoints.b560}px) {
        margin-top: ${theme.size.static400};
      }

      @media (width: ${Breakpoints.b1920}px) {
        gap: ${theme.size.static500};
      }
    `;
  }}
`;

export const StyledInformationContainer: any = styled.div`
  width: 100%;
`;

export const StyledCardsContainer: any = styled.div`
  ${({ theme, hasDescription }: StyledGenericProps) => {
    return `
      align-self: stretch;
      display: grid;
      grid-template-columns: 1fr;
      padding-top: ${hasDescription ? theme.size.static350 : theme.size.static300};
      width: 100%;
      gap: ${theme.size.static250};

      @media(min-width: ${Breakpoints.b560}px) {
        grid-template-columns: repeat(auto-fill, minmax(366px, 1fr));
        gap: ${theme.size.static300};
      }

      @media(min-width: ${Breakpoints.b1920}px) {
        padding-top: ${hasDescription ? theme.size.static400 : theme.size.static350};
        gap: ${theme.size.static350};
        grid-template-columns: repeat(auto-fill, minmax(404px, 1fr));
      }
    `;
  }}
`;

export const StyledUserVehiclesContainer: any = styled.div`
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
`;

export const StyledUserSubscriptionsContainer: any = styled.div`
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
`;

export const StyledButtonsContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      display: flex;
      gap: ${theme.size.static350};
      justify-content: space-between;

      @media (min-width: ${Breakpoints.b560}px) {
        gap: ${theme.size.static400};
      }

      @media (min-width: ${Breakpoints.b1920}px) {
        gap: ${theme.size.static350};
        justify-content: flex-end;
      }
    `;
  }}
`;


